/**
 * Peso e dimensões da embalagem (#MT-12EF108).
 * A mesma embalagem guarda as duas linhas ao mesmo tempo: secundária e terciária.
 * weight/height/width/length continuam sendo as medidas do nível desta embalagem.
 */

export const MEASURE_TAG = {
	P: 'primaria',
	S: 'secundaria',
	T: 'terciaria',
};

/**
 * @param {string|null|undefined} value
 * @returns {'P'|'S'|'T'|null}
 */
export function parseMeasureLevel(value)
{
	const raw = String(value ?? '').trim().toLowerCase();
	const s = raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	if (s === 'p' || s === 'primaria')
		return 'P';
	if (s === 's' || s === 'secundaria')
		return 'S';
	if (s === 't' || s === 'terciaria')
		return 'T';
	return null;
}

/**
 * Onde cada conjunto de campos aparece.
 * own = weight/height/width/length (conferência). alt = a outra linha.
 * @param {string} level
 * @param {'S'|'T'|null} altCode
 * @returns {{ own: 'P'|'S'|'T', alt: 'S'|'T', visible: Array<'P'|'S'|'T'> }}
 */
export function measureHosts(level, altCode)
{
	if (level === 'T')
		return { own: 'T', alt: 'S', visible: ['S', 'T'] };
	if (level === 'P')
	{
		const alt = altCode === 'S' ? 'S' : 'T';
		return { own: 'P', alt, visible: ['P', alt] };
	}
	return { own: 'S', alt: 'T', visible: ['S', 'T'] };
}

/**
 * Tag da segunda linha. Vazia se não houver número.
 * Na primária, a linha extra fica onde o usuário deixou (S ou T).
 * @param {string} level
 * @param {boolean} altFilled
 * @param {'S'|'T'|null} altCode
 * @returns {string|null}
 */
export function altTagForLevel(level, altFilled, altCode)
{
	if (!altFilled)
		return null;
	if (level === 'S')
		return MEASURE_TAG.T;
	if (level === 'T')
		return MEASURE_TAG.S;
	if (altCode === 'S')
		return MEASURE_TAG.S;
	return MEASURE_TAG.T;
}
